"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _thirdSam = _interopRequireDefault(require("@/api/activity/thirdSam.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'expandList',
  components: {},
  props: {
    actId: {
      type: Number,
      default: ''
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newVal) {
        console.log('actId', newVal);
        // 有actId时选中，无actId时不选
        if (newVal && newVal != 'null' && newVal != '') {
          this.searchForm.productId = newVal && newVal != 'null' ? newVal : '';
          this.searchForm.page = 1;
          this.fetchList(newVal);
        }
      }
    }
  },
  data: function data() {
    return {
      times: [],
      productList: [],
      loading: false,
      searchForm: {
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        orderNo: '',
        productId: '',
        status: ''
      },
      tableData: [],
      couponList: [],
      showUserDialog: false,
      // 控制弹窗显示
      exchangeCode: [],
      searchForm2: {
        couponName: '',
        orderNo: '',
        verifyStatus: '',
        page: 1,
        limit: 10,
        total: 0
      },
      downloadLoading: false
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    dateFormat2: function dateFormat2(date, format) {
      var d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return '';
      var map = {
        'yyyy': d.getFullYear(),
        'MM': ('0' + (d.getMonth() + 1)).slice(-2),
        'dd': ('0' + d.getDate()).slice(-2),
        'HH': ('0' + d.getHours()).slice(-2),
        'mm': ('0' + d.getMinutes()).slice(-2),
        'ss': ('0' + d.getSeconds()).slice(-2)
      };
      var fmt = format || 'yyyy-MM-dd HH:mm:ss';
      Object.keys(map).forEach(function (k) {
        fmt = fmt.replace(k, map[k]);
      });
      return fmt;
    },
    download: function download() {
      var _this = this;
      this.downloadLoading = true;
      var params = {
        productId: this.searchForm.productId,
        orderNo: this.searchForm.orderNo,
        mobile: this.searchForm.mobile,
        status: this.searchForm.status
      };
      _thirdSam.default.exportOrderList(params).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '订单列表.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this.downloadLoading = false;
      });
    },
    changeTime: function changeTime(e) {
      console.log(e);
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      _thirdSam.default.getOrdeList(this.searchForm).then(function (res) {
        res.records.forEach(function (item) {
          if (item.createDate) {
            item.createDate = _this2.dateFormat2(item.createDate);
          }
        });
        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.searchForm = {
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        cardNo: ''
      }, this.fetchList();
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange2: function handlePageChange2(newPage) {
      this.searchForm.page2 = newPage;
      this.getUserList();
    },
    handleSizeChange2: function handleSizeChange2(newSize) {
      this.searchForm2.limit = newSize;
      this.searchForm2.page = 1;
      this.getUserList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    handleDetail: function handleDetail(row) {
      this.searchForm2.status = '';
      this.searchForm2.page = 1;
      this.searchForm2.orderNo = row.orderNo;
      this.getUserList();
      this.showUserDialog = true;
    },
    getUserList: function getUserList() {
      var _this3 = this;
      _thirdSam.default.getCouponList(this.searchForm2).then(function (res) {
        _this3.couponList = res.records || [];
        _this3.searchForm2.total = res.total || 0;
      });
    },
    getProducectList: function getProducectList() {
      var _this4 = this;
      var data = {
        keywords: '',
        page: 1,
        limit: 99999
      };
      _thirdSam.default.getProductList(data).then(function (res) {
        _this4.productList = res.records || [];
        if (_this4.productList[0] && (_this4.actId == '' || _this4.actId == 'null')) {
          _this4.searchForm.productId = res.records[0].id;
          _this4.fetchList();
        }
      });
    }
  },
  mounted: function mounted() {
    this.getProducectList();
    // this.fetchList()
  }
};